import {Component, inject, Input, OnInit} from '@angular/core';
import {DeterminationModeApplicationService} from '../services/determination-mode-application.service';
import {TranslateService} from '@ngx-translate/core';
import {isNullOrUndefined} from '../utils/functions';

/**
 * Classe à surcharger par tous les composants de sigale angular.
 */
@Component({ template: '' })
export class AbstractSigaleComponent implements OnInit {
	@Input('modeApplicationCohabitation')
	modeApplicationCohabitation: boolean;
	@Input('modeSigaleBackend1')
	modeSigaleBackend1: boolean = false;
	@Input('nomAlert')
	nomAlert: string;
	classeModeApplication: string;
	determinationModeApplicationService: DeterminationModeApplicationService = inject(DeterminationModeApplicationService);
	translateService: TranslateService = inject(TranslateService);

	constructor() {
	}

	ngOnInit() {
		if (isNullOrUndefined(this.modeApplicationCohabitation)) {
			this.classeModeApplication = this.determinationModeApplicationService.determinerClasseCssModeApplication();
			this.modeApplicationCohabitation = this.determinationModeApplicationService.estModeApplicationCohabitationAngularJsAngular();
		}
		else if (this.modeApplicationCohabitation) {
			this.classeModeApplication = this.determinationModeApplicationService.classeModeCohabitationAngularJsAngular();
		}
		else {
			this.classeModeApplication = this.determinationModeApplicationService.classeModeFullAngular();
		}
		this.chargerTraduction('FR', this.traductionFR());
		this.chargerTraduction('IT', this.traductionIT());
	}

	/**
	 * Charge les traduction de la langue en paramètre
	 *
	 * @param codeLangue le code la langue
	 * @param traductions les traductions de la langue
	 */
	private chargerTraduction(codeLangue: string, traductions: any) {
		if (traductions && this.translateService.currentLang === codeLangue) {
			// Si la langue n'est pas initialisée, on force le reload du fichier *.json pour être sûr de ne pas bloquer la traduction
			if (!this.langueInitialisee(codeLangue)) {
				this.translateService.reloadLang(codeLangue).subscribe(() => this.translateService.setTranslation(codeLangue, traductions, true));
			}
			else {
				this.translateService.setTranslation(codeLangue, traductions, true);
			}
		}
	}

	private langueInitialisee(codeLangue: string): boolean {
		if (this.translateService?.store?.langs) {
			return this.translateService.store.langs.indexOf(codeLangue) != -1;
		}
	}

	traductionFR(): any {
		return null;
	}

	traductionIT(): any {
		return null;
	}
}

